import React from "react";
import { useEffect, useState } from "react";
import * as Survey from "survey-react";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import {
  getTemplate,
  RequestLabTest,
  listHospitalRooms,
} from "../../services/Api";

import moment from "moment";

import { useHistory } from "react-router-dom";

import "survey-react/survey.css";
const LabTestRequest = (props) => {
  const history = useHistory();
  const { patient_info, room } = (props.location && props.location.state) || {};
  const [template, settemplate] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [started, setSaterted] = useState();
  const [LabRoomID, setLabRoomID] = useState(null);
  
  useEffect(() => {
    getLabRequestTemplate();
    getConsultationRooms();
    setSaterted(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

    console.log(get_lab_room());
    return () => {};
  }, []);

  const get_lab_room = () => {
    let lab = JSON.parse(localStorage.getItem("rooms"))?.filter((obj) => {
      return obj.serial_no === 10;
    })[0];
    return lab;
  };

  const getConsultationRooms = (e) => {
    setIsloading(true);
    listHospitalRooms({ hospital_id: room.hospital_id })
      .then((res) => {
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            response.data?.map((r) => {
              if (r.serial_no == 10) {
                setLabRoomID(r.id);
              }
            });

            // {
            //   room_id: "9d261113-7907-11ec-b2a0-c8e265950377",
            //   hospital_id: "643f44b9-7905-11ec-b2a0-c8e265950222",
            //   room_name: "BIRTH SPACING",
            //   serial_no: 7,
            // }
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
  const _submit = (form_result) => {
    console.log(form_result.valuesHash);

    let payload = {
      visit_id: patient_info.visit_id,
      from_room_id: room.room_id,
      room_id: LabRoomID,
      lab_request: { lab: JSON.stringify(form_result.valuesHash.lab) },
      lab_result: null,
    };
    console.clear();
    console.log(payload);

    setIsloading(true);
    RequestLabTest(payload)
      .then((res) => {
        setIsloading(false);
        var response = res.data;

        console.log(res);
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.log(response);

            cogoToast.success("Lab Request Created Successfully", {
              hideAfter: 5,
            });
            //   history.push({
            //     pathname: "/hmis/print-visit",
            //     state: {
            //       visit: response.data,

            //     },
            //   });
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  const getLabRequestTemplate = () => {
    setIsloading(true);

    getTemplate({ template_name: "lab-test-request" })
      .then((res) => {
        console.log(res);
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;

          let tmp = response.data[0].template;
          settemplate(tmp);

          if (response.status == SUCCESS_RESULT) {
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  return (
    <h1>
     
      <h1 className="alert alert-primary">
      LAB REQUEST  ➤    {patient_info.name}
            </h1>
      
      <hr />
      <hr />
      <div className="d-flex justify-content-center my-1">
        {Isloading && <Spinner />}
      </div>
      {template != null && (
        <Survey.Survey json={template} onComplete={(data) => _submit(data)} />
      )}
    </h1>
  );
};

export default LabTestRequest;
